import { render, staticRenderFns } from "./TeacherLayout.vue?vue&type=template&id=debabd50&lang=pug&"
import script from "./TeacherLayout.vue?vue&type=script&lang=js&"
export * from "./TeacherLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports